<template>
  <section id="articles">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div v-else class="sectionCnt">
      <div class="sectionHeader">
        <h2>Seputar Iklim</h2>
        <div class="searchCnt">
          <input type="text" class="search" placeholder="Search...">
          <button class="searchBtn"></button>
        </div>
      </div>
      <div class="noData" v-if="!results || results.length < 1">
        <h4>Belum ada Seputar Iklim</h4>
        <p>Belum ada data Seputar Iklim untuk ditampilkan, periksa kembali lagi nanti.</p>
      </div>
      <div class="sectionSm" v-else>
        <div class="sItem">
          <a href="/bicarabumi/seputariklim/no-nukes" class="sItemIn">
            <div class="sImg no-nukes"></div>
            <div class="sInfo">
              <h4>365 Alasan Untuk Menentang Kekuatan Nuklir</h4>
              <p>Apa yang kamu bayangin ketika mendengar kata nuklir?
              Ledakan dahsyat, radioaktif, perang, atau bahkan sumber energi?</p>
            </div>
          </a>
        </div>
        <div class="sItem" v-if="1>2">
          <a href="/beraksi/week-of-resistance" class="sItemIn">
            <div class="sImg noImg"></div>
            <div class="sInfo">
              <h4>Week Of Resistance</h4>
              <p>Tujuh hari menjelang lima tahun Paris Agreement disegel.
                194 negara telah berkomitmen untuk menahan laju peningkatan...</p>
            </div>
          </a>
        </div>
        <div class="sItem">
          <a href="/beraksi/tenggelam-dalam-diam" class="sItemIn">
            <div class="sImg tenggelamDalamDiam"></div>
            <div class="sInfo">
              <h4>Mengabarkan Kita Tenggelam</h4>
              <p>Kenaikan suhu bumi yang kian tak terbendung telah mengantar
                krisis iklim semakin menumpahkan dampak-dampak penuh ancaman...</p>
            </div>
          </a>
        </div>
        <div class="sItem">
          <a href="/beraksi/global-climate-strike" class="sItemIn">
            <div class="sImg climateStrike"></div>
            <div class="sInfo">
              <h4>Global Climate Strike</h4>
              <p>Anak muda di berbagai belahan dunia sedang bergerak dan
                memperjuangkan masa depannya untuk memerangi Krisis Iklim...</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: false,
      prevScrollpos: 0,
      hideHeader: false,
      krisisIklim: [],
      kabarIklim: [],
      infografis: [],
      gpArticles: [],
      humansOfClimate: [],
      podcast: [],
      shortMovie: [],
      page: '',
      bumiKiniInitialized: false,
      bicaraBumiInitialized: false,
      menuActive: '',
      results: ['a'],
    };
  },
  computed: {
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    this.prevScrollpos = window.pageYOffset;
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    viewContent(item) {
      if (item.type === 'Article') {
        this.$router.push(`/${item.parent.slug}/read/${item.slug}`);
      } else {
        this.$emit('viewContent', item);
      }
    },
    viewLink(item) {
      if (item.event && item.event.url) {
        window.open(item.event.url);
      }
    },
    onScrolled() {
      if (this.page === 'sumber-dan-materi') {
        const kabarIklimRect = this.$refs.kabarIklim.getBoundingClientRect();
        const kabarIklimOffTop = kabarIklimRect.top + window.pageYOffset;
        const infografisRect = this.$refs.infografis.getBoundingClientRect();
        const infografisOffTop = infografisRect.top + window.pageYOffset;
        const articleRect = this.$refs.gpArticles.getBoundingClientRect();
        const articleOffTop = articleRect.top + window.pageYOffset;
        if (window.pageYOffset >= articleOffTop) {
          this.menuActive = 'articles';
        } else if (window.pageYOffset >= infografisOffTop) {
          this.menuActive = 'infografis';
        } else if (window.pageYOffset >= kabarIklimOffTop) {
          this.menuActive = 'kabar-iklim';
        } else {
          this.menuActive = 'krisis-iklim';
        }
      } else if (this.page === 'bicara-bumi') {
        const podcastRect = this.$refs.podcast.getBoundingClientRect();
        const podcastOffTop = podcastRect.top + window.pageYOffset;
        const shortMovieRect = this.$refs.shortMovie.getBoundingClientRect();
        const shortMovieOffTop = shortMovieRect.top + window.pageYOffset;
        if (window.pageYOffset >= podcastOffTop) {
          this.menuActive = 'podcast';
        } else if (window.pageYOffset >= shortMovieOffTop) {
          this.menuActive = 'short-movie';
        } else {
          this.menuActive = 'humans-of-climate';
        }
      }
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 300) {
        if (this.prevScrollpos > currentScrollPos) {
          this.hideHeader = false;
        } else {
          this.hideHeader = true;
        }
      } else {
        this.hideHeader = false;
      }
      this.prevScrollpos = currentScrollPos;
    },
    getData() {
      this.chMenuActive(this.page);
      if (this.page === 'sumber-dan-materi') {
        this.menuActive = 'krisis-iklim';
        if (!this.bumiKiniInitialized) {
          this.loading = true;
          this.bumiKiniInitialized = true;
          this.$http.get(this.$config.uri('article/all?parent=krisis-iklim'))
            .then((response) => {
              this.krisisIklim = (response.data.status === 200) ? response.data.data : [];
              // this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=kabar-dan-berita'))
            .then((response) => {
              this.kabarIklim = (response.data.status === 200) ? response.data.data : [];
              // this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=infografis'))
            .then((response) => {
              this.infografis = (response.data.status === 200) ? response.data.data : [];
              this.loading = false;
            });
          this.$http.get(this.$config.uri('article/all?parent=external-article'))
            .then((response) => {
              this.gpArticles = (response.data.status === 200) ? response.data.data : [];
            });
        } else {
          this.loading = false;
        }
      } else if (this.page === 'bicara-bumi') {
        this.menuActive = 'humans-of-climate';
        if (!this.bicaraBumiInitialized) {
          this.loading = true;
          this.bicaraBumiInitialized = true;
          this.$http.get(this.$config.uri('article/all?parent=humans-of-climate'))
            .then((response) => {
              this.humansOfClimate = (response.data.status === 200) ? response.data.data : [];
              this.loading = false;
            });
          this.$http.get(this.$config.uri('podcast/all/kelas-iklim')).then((response) => {
            this.podcast = (response.data.status === 200) ? response.data.data : [];
            this.loading = false;
          });
          this.$http.get(this.$config.uri('podcast/all/short-movie')).then((response) => {
            this.shortMovie = (response.data.status === 200) ? response.data.data : [];
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.params.slug;
      this.getData();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    this.page = this.$route.params.slug;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = (this.page === 'bicara-bumi')
      ? 'Bicara Bumi - Bumi Butuh Aksi'
      : 'Sumber dan Materi - Bumi Butuh Aksi';
    this.getData();
  },
};
</script>

<style scoped lang="scss">
#articles{
  min-height: 100vh;
  background-color: #33375a;
  box-sizing: border-box;
  padding-top: 80px;
  color: #fff;
}

.sectionCnt{
  max-width: 1240px;
  margin: 0 auto;
  @media (max-width: 1300px) {
    max-width: none;
    margin: 0 20px;
  }
  @media (max-width: 680px) {
    margin: 0 16px;
  }
}

.sectionHeader{
  border-bottom: rgba(255,255,255,.7) 2px solid;
  position: relative;
  padding: 60px 0 10px;
  margin-bottom: 30px;
  @media (max-width: 1200px) {
    padding-top: 30px;
  }
  @media (max-width: 960px) {
    padding-top: 20px;
    // border-bottom: none;
    margin-bottom: 10px;
  }
  @media (max-width: 680px) {
    padding-top: 0;
  }
  h2{
    font-size: 64px;
    font-weight: 800;
    margin: 0;
    @media (max-width: 1200px) {
      font-size: 46px;
    }
    @media (max-width: 680px) {
      font-size: 34px;
      margin-bottom: 4px;
    }
  }
  .searchCnt{
    position: absolute;
    right: 0; top: 80px;
    display: none;
    input{
      border: none;
      background-color: #fff;
      font-size: 16px;
      padding: 10px 20px;
      line-height: 1;
      border-radius: 50px;
      border: #ddd 1px solid;
      width: 300px;
    }
    button{
      position: absolute;
      border: none;
      background-color: #fff;
      width: 30px; height: 30px;
      right: 10px; top: 4px;
      background-image: url(../assets/loupe.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
    }
  }
}

.sectionSm{
  display: flex;
  margin: 0 -15px;
  flex-wrap: wrap;
  padding-bottom: 60px;
  .sItem{
    width: 33.33333%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-bottom: 30px;
    color: #444;
    @media (max-width: 960px) {
      width: 50%;
    }
    @media (max-width: 680px) {
      width: 100%;
    }
    .sItemIn{
      background-color: #fff;
      display: block;
      color: #444;
      text-decoration: none;
    }
    .sImg{
      height: 280px;
      background-color: #eee;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/no-nukes.jpg);
      &.tenggelamDalamDiam{
        background-image: url(../assets/tenggelam-dalam-diam-cover.jpg);
      }
      &.climateStrike{
        background-image: url(../assets/climate-thumb.jpg);
      }
      &.noImg{
        background-image: url(../assets/logo-grey.png);
        background-size: 140px auto;
      }
      @media (max-width: 1100px) {
        height: 240px;
      }
    }
    .sInfo{
      padding: 14px 20px 20px;
      h4{
        margin: 0;
        font-size: 24px;
      }
      p{
        margin: 0;
        font-size: 14px;
      }
    }
  }
}

.loading{
  padding-top: 80px;
  position: relative;
  overflow: hidden;
  &:before{
    content: "";
    display: block;
    position: absolute;
    top: -40px;
    bottom: -40px;
    left: -200px;
    width: 200px;
    background-image: linear-gradient(to right, transparent,#fff,transparent);
    transform: rotate(14deg);
    z-index: 2;
    animation: skAnimate 2.2s infinite;
    opacity: .8;
    @keyframes skAnimate {
      from { left: -200px; }
      to { left: calc(100% + 200px); }
    }
  }
  .lMT{
    height: 42px;
    background-color: #eee;
  }
  .lWrp{
    max-width: 1240px;
    margin: 0 auto;
  }
  .loadingCnt{
    &.loadingCnt2{
      margin-top: 94px;
      padding-top: 3px;
      .ttl{
        background-color: #eee;
      }
      .lIt{
        background-color: #eee;
      }
      &.loadingCnt3{
        margin-top: 104px;
        margin-bottom: 80px;
        background-color: #fff;
        .lIt{
          height: 524px;
        }
      }
    }
    .ttl{
      height: 30px;
      background-color: #eee;
      margin-bottom: 29px;
      max-width: 200px;
      &.ttl1{
        margin-top: 39px;
      }
    }
    .lItCnt{
      display: flex;
      margin: 0 -10px;
    }
    .lIt{
      height: 295px;
      width: calc(25% - 20px);
      margin: 0 10px;
      background-color: #eee;
    }
  }
}

.noData{
  padding: 18px;
  background-color: rgba(0,0,0,.1);
  h4{
    font-size: 24px;
    margin: 0 0 4px;
  }
  p{
    margin: 0;
  }
}

</style>
